import detect from 'detector';

export function isFirefox() {
    return detect.browser.name === 'firefox';
}

export function isChrome() {
    return detect.browser.name === 'chrome';
}

export function isWindows10() {
    return detect.os.name === 'windows' && detect.os.version === 10;
}

export function isMobileSafari() {
    return detect.browser.name === 'safari' && detect.os.name === 'ios' && detect.os.version >= 11;
}

export function isDesktopSafari() {
    return detect.browser.name === 'safari' && detect.device.name === 'mac';
}

export function isDesktopSafari12() {
    return detect.browser.name === 'safari' && detect.os.name === 'macosx' && detect.browser.version >= 12;
}

export function isiOSChrome() {
    return isChrome() && detect.os.name === 'ios';
}

export function isMobile() {
    return detect.os.name === 'android' || detect.os.name === 'ios';
}

export function isMobileAndroid() {
    return detect.os.name === 'android';
}



// WEBPACK FOOTER //
// ./src/sources/webrtc/streams/browserDetector.js